<!-- ------------------------Modal Section Start-------------------------------- -->
<div class="nav_Consult">
    <a class="rs_small_btn" mat-button (click)="openDialog()"> {{ButtonName}} </a>
</div>